import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { trainingApi } from "../../services";
import { useLocation } from 'react-router-dom';
import { useFormik } from "formik";

export default function TrainingValidation() {
  const navigate = useNavigate();
  const location = useLocation(); 
  const [skillRating, setSkillRating] = useState(null);
  const [feedback, setFeedback] = useState("");
  const [skillRatingOptions, setSkillRatingOptions] = useState([]);
  const { trainingData } = location.state || {};
  const formik = useFormik({
      initialValues: {
        targetSkill: "",
        nameOfNominatedParticipant: "",
        categoryOfTraining: "",
        comments: "",
      },
      validate: (data) => {
        let errors = {};
        if (!data.skills) {
          errors.skills = "Skill is required.";
        }
        return errors;
      },
      onSubmit: (data) => {
        // save(data);
      },
    });

  useEffect(() => {
    fetchRatings();
  }, []);

  useEffect(() => {
   if(trainingData){
    formik.setFieldValue("categoryOfTraining", trainingData?.categoryOfTrainings?.title);
    formik.setFieldValue("targetSkill", trainingData?.targetSkills?.title);
    formik.setFieldValue(
      "nameOfNominatedParticipant",
      trainingData?.nameOfNominatedParticipant
    );
   }
  }, []);

  const fetchRatings = () => {
    trainingApi.getRatings().then((resp) => {
      resp.data.data.sort((a, b) => a.code - b.code);
      setSkillRatingOptions(resp.data.data);
    });
  };

  const handleSubmit = () => {
    //todo
    const dataObj = {
      training_type: "",
      target_skill: "",
      employee_name: "",
      category_of_training: "",
      feedback: feedback,
      skill_rating_update: skillRating,
      completion_certificate: "",
    };
    navigate("/training-effectiveness-feedback");
  };

  return (
    <div className="card">
      <div className="col">
        <h1 className="p-0 training-heading">Training Validation</h1>
        <hr></hr>
      </div>
      <div className="flex flex-wrap p-field font-bold block">
        <div className="col-4">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Training Type
          </label>
          <InputText disabled placeholder="Training Type"  value={formik.values.categoryOfTraining} className="w-full" />
        </div>
        <div className="col-4">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Target Skill
          </label>
          <InputText disabled placeholder="Target Skill"  value={formik.values.targetSkill} className="w-full" />
        </div>
        <div className="col-4">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Employee Name
          </label>
          <InputText disabled placeholder="Name" value={formik.values.nameOfNominatedParticipant} className="w-full" />
        </div>
        <div className="col-4">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Category Of Training
          </label>
          <InputText disabled placeholder="Training" className="w-full" />
        </div>
        <div className="col-4">
          <label
            htmlFor="text"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Training Completion Certificate
          </label>
          <Button
            label="Download Certificate"
            icon="pi pi-download"
            className="w-full bg-bluegray-600 hover:bg-bluegray-400 border-bluegray-700"
          />
        </div>
        <div className="col-4">
          <label
            htmlFor="skillRating"
            className="font-bold block mb-2 training-heading mt-2"
          >
            Skill Rating Update
          </label>
          <Dropdown
            value={skillRating}
            onChange={(e) => setSkillRating(e.value)}
            options={skillRatingOptions}
            optionLabel={(option) => `${option.code} - ${option.title}`}
            placeholder="Select Skill Rating"
            className="w-full"
          />
        </div>
        <div className="col-12">
          <label
            htmlFor="feedback"
            className="font-bold block mb-2 training-heading"
          >
            Feedback
          </label>
          <InputTextarea
            id="feedback"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            rows={4}
            placeholder="Provide your feedback here"
            className="w-full"
            style={{ background: "#fff" }}
          />
        </div>
      </div>
      <div className="flex flex-wrap p-field font-bold block mt-2">
        <div className="col-12">
          <p className="guidelines">
            <strong>Skill Updating Guidelines:</strong> Ensure that the feedback
            is constructive and aligns with the skill development goals. Ratings
            should reflect the employee's performance in the training.
          </p>
        </div>
      </div>
      <div className="flex flex-wrap p-field font-bold block mt-4">
        <div className="col-12 flex">
          <Button label="Submit" onClick={handleSubmit} />
          <Button
            label="Back"
            className="ml-2"
            severity="secondary"
            onClick={() => navigate("/trf-approval/1")}
          />
        </div>
      </div>
    </div>
  );
}
